'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAssignedAgentFromV1Message = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _setters = require('../../operators/conversation/setters');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var _assignmentV1MessageMetadataGetters = require('../../assignment-v1-message-metadata/operators/assignmentV1MessageMetadataGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setAssignedAgentFromV1Message = exports.setAssignedAgentFromV1Message = (0, _curry2.default)(function (assignmentV1Message, thread) {
  var agentId = (0, _pipe2.default)(_pubnubMessageGetters.getMetadata, _assignmentV1MessageMetadataGetters.getAgentId)(assignmentV1Message);
  return (0, _setters.setAssignedAgentId)(agentId, thread);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread/operators/setAssignedAgentFromV1Message.js
// module id = 870
// module chunks = 2 3